
// Error types
const COMPILE_ERROR = 1002
const EXECUTION_ERROR = 1003

// Error kind
const NULL_VARIABLE = 2002
const INDEX_OUT_OF_RANGE = 2003
const INCOMPATIBLE_TYPE = 2004
const BOOLEAN_READ = 2005
const ARITMETIC_ERROR = 2006
const UNDEFINED_ERROR = 2007

function GenericError (message, type, kind, array, index, ins) {
    this.type = type
    this.kind = kind
    this.index = index
    this.array = array
    this.message = message
    if (ins && ins.debug) {
        this.fromLine = ins.debug.fromLine
        this.toLine = ins.debug.toLine
        this.fromCol = ins.debug.fromColumn
        this.toCol = ins.debug.toColumn
        this.lexeme = ins.debug.ident
    } else {
        this.fromLine = 0
        this.toLine = 0
        this.fromCol = 0
        this.toCol = 0
        this.lexeme = ''
    }
}

GenericError.prototype = {
    // Boolean getters
    isCompileError () {
        return this.type === COMPILE_ERROR
    },
    isExecutionError () {
        return this.type === EXECUTION_ERROR
    },
    isNullVariable () {
        return this.kind === NULL_VARIABLE
    },
    isArray () {
        return this.array
    },
    isOutOfRange () {
        return this.kind === INDEX_OUT_OF_RANGE
    },
    isIncompatibleType () {
        return this.kind === INCOMPATIBLE_TYPE
    },
    isBooleanRead () {
        return this.kind === BOOLEAN_READ
    },
    isAritmetic () {
        return this.kind === ARITMETIC_ERROR
    },
    isUndefined () {
        return this.kind === UNDEFINED_ERROR
    },

    // Boolean setters
    setAsCompileError () {
        this.type = COMPILE_ERROR
    },
    setAsExecutionError () {
        this.type = EXECUTION_ERROR
    },
    setAsNullVariable () {
        this.kind = NULL_VARIABLE
    },
    setAsArray () {
        this.array = true
    },
    setAsOutOfRange () {
        this.kind = INDEX_OUT_OF_RANGE
    },
    setAsIncompatibleType () {
        this.kind = INCOMPATIBLE_TYPE
    },
    setAsBooleanRead () {
        this.kind = BOOLEAN_READ
    },
    setAsAritmetic () {
        this.kind = ARITMETIC_ERROR
    },
    setAsUndefined () {
        this.kind = UNDEFINED_ERROR
    },

    // Setters
    setLexeme (lexeme) {
        this.lexeme = lexeme
    },
    setFromLine (line) {
        this.fromLine = line
    },
    setToLine (line) {
        this.toLine = line
    },
    setFromCol (col) {
        this.fromCol = col
    },
    setToCol (col) {
        this.toCol = col
    },
    setIndex (index) {
        this.index = index
    },
    setMessage (message) {
        this.message = message
    },

    // Getters
    getLexeme () {
        return this.lexeme
    },
    getFromLine () {
        return this.fromLine
    },
    getToLine () {
        return this.toLine
    },
    getFromCol () {
        return this.fromCol
    },
    getToCol () {
        return this.toCol
    },
    getIndex () {
        return this.index
    },
    getMessage () {
        return this.message
    }
}

function CompileError (message) {
    return new GenericError(message, COMPILE_ERROR)
}

function ExecutionError (message) {
    return new GenericError(message, EXECUTION_ERROR)
}

function NullVariableError (message, ins) {
    return new GenericError(message, EXECUTION_ERROR, NULL_VARIABLE, false, 0, ins)
}

function IndexOutOfRangeError (message, index, ins) {
    return new GenericError(message, EXECUTION_ERROR, INDEX_OUT_OF_RANGE, true, index, ins)
}

function NullArrayVariableError (message, index, ins) {
    return new GenericError(message, EXECUTION_ERROR, NULL_VARIABLE, true, index, ins)
}

function IncompatibleTypesError (message, ins) {
    return new GenericError(message, EXECUTION_ERROR, INCOMPATIBLE_TYPE, false, 0, ins)
}

function BooleanReadError (message, ins) {
    return new GenericError(message, EXECUTION_ERROR, BOOLEAN_READ, false, 0, ins)
}

function AritmeticError (message, ins) {
    return new GenericError(message, EXECUTION_ERROR, ARITMETIC_ERROR, false, 0, ins)
}

function UndefinedError (message, ins) {
    return new GenericError(message, EXECUTION_ERROR, UNDEFINED_ERROR, false, 0, ins)
}

export {GenericError, CompileError, ExecutionError, NullVariableError, IndexOutOfRangeError, NullArrayVariableError, IncompatibleTypesError, BooleanReadError, AritmeticError, UndefinedError}



// WEBPACK FOOTER //
// ./src/Core/VirtualMachine/ErrorTypes.js